import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Col';
import { ReactComponent as HappyMealBoxSvg } from '../../assets/svg/happy-meal-box.svg';
import LanguageDropdown from '../LanguageDropdown.js';
import { withRouter } from 'react-router';
import VizSensor from 'react-visibility-sensor';
import {Link} from 'react-router-dom';
import { formatText } from './Legal';
import { AnimationContext } from './Home';


class FAQ extends Component {
  static contextType = AnimationContext;
  constructor(props) {
    super(props);
    this.state = {
      text: {},
      headerVisible: false,
      rightAlignLang: ['ara', 'heb'],
      lang: 'en',
    }
  }

  componentDidMount() {
    this.getTranslations();
    setTimeout(() => {
      this.context.setIntro(false);
      this.context.setshowStore(true);
    }, 2000);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.getTranslations();
      const lang = this.props.match.params.id || 'en';
      this.setState({ lang });
    }
  }

  getTranslations() {
    let lang = 'en';
    if (this.props.match.params.id) {
      lang = this.props.match.params.id;
      this.setState({ lang });
    }
    try {
      const text = require(`../../data/faq/${lang}.json`);
      this.setState({ text });
    }
    catch (e) {
      const text = require(`../../data/faq/en.json`);
      this.setState({ text });
    }
  }

  addLineBreaks = string => {
    if (string) {
      return string.split('\n').map((text, index) => (
        <React.Fragment key={`${text}-${index}`}>
          {text}
          <br />
        </React.Fragment>
      ));
    }
  }

  render() {
    const { text, headerVisible, rightAlignLang, lang } = this.state;
    return (
      <div className="wrapper legal">
        {/* <Particles /> */}
        <div className={`sticky-header ${headerVisible ? 'fadeIn' : ''}`}>
          <Link to="/"><HappyMealBoxSvg /></Link>
          <LanguageDropdown url="/faq/" />
        </div>

        <Container>
          <VizSensor partialVisibility onChange={(isVisible) => { this.setState({ headerVisible: !isVisible }) }}>
            <Row>
              <Col className="header">
                <div className="logo">
                  <Link to="/"><HappyMealBoxSvg /></Link>
                </div>
                <LanguageDropdown url="/faq/" />
              </Col>
            </Row>
          </VizSensor>

          <Row dir={rightAlignLang.includes(lang) ? 'rtl' : 'ltr'} className={`content ${rightAlignLang.includes(lang) ? 'text-right' : ''}`}>
            <Col>
              <h2>{text.faq_header}</h2>
              <div className="section">
                <h4>{text.faq_question_1}</h4>
                <p>{formatText(text.faq_answer_1)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_2}</h4>
                <p>{formatText(text.faq_answer_2)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_3}</h4>
                <p>{formatText(text.faq_answer_3)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_4}</h4>
                <p>{formatText(text.faq_answer_4)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_5}</h4>
                <p>{formatText(text.faq_answer_5)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_6}</h4>
                <p>{formatText(text.faq_answer_6)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_7}</h4>
                <p>{formatText(text.faq_answer_7_1)}</p>
                <p>{formatText(text.faq_answer_7_2)}</p>
                <p>{formatText(text.faq_answer_7_3)}</p>
                <p>{formatText(text.faq_answer_7_4)}</p>
                <p>{formatText(text.faq_answer_7_5)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_8}</h4>
                <p>{formatText(text.faq_answer_8_1)}</p>
                <p>{formatText(text.faq_answer_8_2)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_9}</h4>
                <p>{formatText(text.faq_answer_9)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_10}</h4>
                <p>{formatText(text.faq_answer_10)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_11}</h4>
                <p>{formatText(text.faq_answer_11)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_12}</h4>
                <p>{formatText(text.faq_answer_12)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_13}</h4>
                <p>{formatText(text.faq_answer_13)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_14}</h4>
                <p>{formatText(text.faq_answer_14)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_14}</h4>
                <p>{formatText(text.faq_answer_14)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_15}</h4>
                <p>{formatText(text.faq_answer_15)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_16}</h4>
                <p>{formatText(text.faq_answer_16)}</p>
              </div>
              <div className="section">
                <h4>{text.faq_question_17}</h4>
                <p>{formatText(text.faq_answer_17)}</p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default withRouter(FAQ);